// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"COxLB","player":"_3OH9p","thumbnail":"_2n5vK","overlay":"_2Vjmp","button":"_1CRa8","arrow":"_24UcX","icon":"_3PTRV"};